import { render, staticRenderFns } from "./WatsonEntities.vue?vue&type=template&id=77314bce&scoped=true&"
import script from "./WatsonEntities.vue?vue&type=script&lang=js&"
export * from "./WatsonEntities.vue?vue&type=script&lang=js&"
import style0 from "./WatsonEntities.vue?vue&type=style&index=0&id=77314bce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77314bce",
  null
  
)

export default component.exports